import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { Drawer as AntdDrawer, Menu } from 'antd';

import { useAppSelector } from '@/hooks/redux';
import { toggleDrawer } from '@/redux/drawer/slice';
import styled, { StyledProp } from '@/styled';

import { navbarItems } from '..';

const Drawer = (props: StyledProp) => {
  const user = useAppSelector(state => state.auth.user);
  const { pathname: currentPath } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const opened = useAppSelector(store => store.drawer.opened);

  if (!user) {
    return null;
  }

  const goTo = (to: string) => () => {
    dispatch(toggleDrawer());
    navigate(to);
  };

  return (
    <AntdDrawer rootClassName={props.className} width={258} open={opened} placement='left' closable={false}>
      <Menu>
        {navbarItems.map(({ path, label }, index) => (
          <Menu.Item key={index} icon={<div className='dot' data-active={path === currentPath} />} onClick={goTo(path)}>
            {label}
          </Menu.Item>
        ))}
      </Menu>
    </AntdDrawer>
  );
};

export default styled(Drawer)`
  top: ${({ theme }) => theme.variables.headerHeight}px;

  .ant-drawer-body {
    padding: ${({ theme }) => theme.space.spacing(9, 0)};
  }

  ul {
    border: none;
  }

  li {
    display: flex;
    align-items: center;
    margin: 0;
    width: 100%;
    padding: ${({ theme }) => theme.space.spacing(0, 4)};

    .dot {
      margin-right: ${({ theme }) => theme.space.spacing(8)};
      min-width: 8px !important;
      max-width: 8px !important;
      width: 8px !important;
      height: 8px;
      background: ${({ theme }) => theme.palette.brand.primary};
      border-radius: 16px;
      opacity: 0;

      &[data-active='true'] {
        opacity: 1;
      }
    }
  }
  .ant-typography {
    margin: 0;
  }
`;
